import React, { useState } from 'react'

import { firestore } from '../../../../../firebase';

function DeleteGeneratedTeams({hostcupId, roundId, teamDrawId, setTeamDraw}) {

    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    async function deleteHandler(e) {
        e.preventDefault();
        try {
            const teamsRoundRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("teams").doc(teamDrawId);
            teamsRoundRef.delete();
            setMessage("Slettet")
            setTeamDraw(null)
        } catch (error) {
            setError("Kunne ikke slette");
            console.log(error)
        }
    }

    return (
        <form onSubmit={deleteHandler}>

            

            {error && <div className="alert alert-danger">{error}</div>}
            {message && <div className="alert alert-success">{message}</div>}
            <button className="btn btn-danger btn-block">Slett lag</button>
        </form>
    )

}
export default DeleteGeneratedTeams
